import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { Flex } from '@withjoy/joykit';
import { InlineValueProps, ListValueProps } from '../ValueProps/ValueProps';
import { useDigitalValuePropSections } from './useDigitalValuePropSections';

export const DigitalValueProps = (props: BoxProps) => {
  const { inline, sections } = useDigitalValuePropSections();

  return (
    <Flex
      flexDirection="column"
      rowGap={7}
      {...props}
    >
      <InlineValueProps
        // The column's rowGap spaces the row from the lists below.
        marginBottom={0}
        items={inline.map(({ icon, description }) => ({ icon, description }))}
      />
      {sections.map(section => (
        <ListValueProps
          key={section.key}
          sectionTitle={section.title}
          items={section.items.map(({ icon, title, description }) => ({ icon, title, description }))}
        />
      ))}
    </Flex>
  );
};
